@if(init){
<div id="box">
  <div [style.background-attachment]="'fixed'" [style.background-repeat]="'no-repeat'" class="app-theme bgimage"
    [style.backgroundImage]="'url(' + serverPath5 + homePageBackgroundImgSrc + ')'" style="background: white;"
    [ngClass]="theme">
    <!-- <calsoft-custom-side-name [isOpen]="calsoftService.sidenavOpen" [data]="finalData" [sideMenuItem]="categoryArray"
      (close)="calsoftService.sidenavOpen = false"></calsoft-custom-side-name> -->
    <div [ngClass]="homePageBackgroundEnable  =='1' ? 'wrap-container' :'' " style="background: white;"
      [ngStyle]="{'height': heightSet ? '100vh' : 'auto'}" class="page-container">
      <div class="page-content"  (scroll)="onScrollEvent($event)">
        <div>
          @if (!url.includes('/course-detail/')) {
          <div>
            @if (type !== 'six' && type!=='twentyfour' && type !== 'five' && type !=='seven' && type !=='eight' && type
            !=='nine' && type !=='ten'
            && type !=='twelve' && type !=='thirteen' && type !=='fifteen' && type !=='sixteen' && type !=='twenty') {
            <div>
              @if (headerEnabled&&!headerBannerRotateEnable) {
              <div [style.background-color]="finalData.headerBannerBackgroundColors"
                [style.backgroundImage]="'url(' + serverPath2 + headerLogoSrc + ')'"
                class="promo-top w-100 h-auto text-center theme-container">
                <div class="copy-container">
                  <div class="flex-container">
                    <h4 [style.color]="finalData.headerBannerTextColour"
                      class="font-weight-normal text-uppercase text-white m-0">
                      {{finalData.headerNotificationContent}}
                    </h4>  
                    @if (finalData.headerBannerCopyEnable) {
                    <h4 [style.color]="finalData.headerBannerTextColour"
                      class="font-weight-normal text-uppercase text-white m-0">
                      {{finalData.headerBannerCopyCoupon}}
                    </h4>
                    }   
                    @if (finalData.headerBannerCopyEnable) {
                    <button (click)="copyToClipboard(finalData.headerBannerCopyCoupon)">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    }
                  </div>
                </div>
              </div>
              }
              @if (headerEnabled&&headerBannerRotateEnable) {
              <div [style.backgroundImage]="'url(' + serverPath2 + headerLogoSrc + ')'"
                class="promo-top w-100 h-auto text-center theme-container">
                <div class="copy-container" [ngClass]="finalData.headerBannerRotateEnable==1 ? 'marquee-text' : ''">
                  <div class="flex-container">
                    <h4 [style.color]="finalData.headerBannerTextColour"
                      class="font-weight-normal text-uppercase text-white m-0">
                      {{finalData.headerNotificationContent}}
                    </h4>  
                  </div>
                </div>
              </div>
              }
            </div>
            }
          </div>
          }
          @if (!url.includes('/course-detail/') && !this.loginPage ) {
          <div style="width: 100%;">

            <!-- @if (type == 'one') {
            <calsoft-header [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header>
            }
            @if (type == 'two' ) {
            <HeaderTwo [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray"></HeaderTwo>
            }
            @if (type == 'three') {
            <calsoft-header-three [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header-three>
            }
            @if (type == 'four') {
            <HeaderFour [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray"></HeaderFour>
            }
            @if (type == 'five') {
            <calsoft-header-five [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header-five>
            }
            @if (type == 'six') {
            <calsoft-header-six [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header-six>
            }
            @if (type == 'seven') {
            <calsoft-header-seven [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header-seven>
            }
            @if (type == 'eight') {
            <calsoft-header-eight [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header-eight>
            }
            @if (type == 'nine') {
            <calsoft-headernine [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-headernine>
            }
            @if (type == 'ten') {
            <calsoft-header10 [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header10>
            }
            @if (type == 'eleven') {
            <calsoft-header11 [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header11>
            }
            @if (type == 'twelve') {
            <calsoft-header12 [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header12>
            }
            @if (type == 'thirteen') {
            <calsoft-header13 [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header13>
            }
            @if (type == 'fourteen') {
            <calsoft-header14 [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header14>
            }
            @if (type == 'fifteen') {
            <calsoft-header15 [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header15>
            }
            @if (type == 'sixteen') {
            <calsoft-header16 [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header16>
            }
            @if (type == 'seventeen') {
            <calsoft-header17 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray"
              [containerClass]="containerClass"></calsoft-header17>
            }
            @if (type == 'eighteen') {
            <calsoft-header18 [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray"></calsoft-header18>
            }
            @if (type == 'nineteen') {
            <calsoft-header19 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header19>
            }
            @if (type == 'twenty') {
            <calsoft-header20 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header20>
            }
            @if (type == 'twentyone') {
            <calsoft-header21 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header21>
            }
            @if (type == 'twentytwo') {
            <calsoft-header22 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header22>
            }
            @if (type == 'twentythree') {
            <calsoft-header23 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header23>
            }
            @if (type == 'twentyfour') {
            <calsoft-header24 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header24>
            }
            @if (type == 'twentyfive') {
            <calsoft-header25 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header25>
            }
            @if (type == 'twentysix') {
            <calsoft-header26 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header26>
            }
            @if (type == 'twentyseven') {
            <calsoft-header27 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header27>
            }
            @if (type == 'twentyeight') {
            <calsoft-header28 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header28>
            }
            @if (type == 'twentynine') {
            <calsoft-header29 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header29>
            }
            @if (type == 'thirty') {
            <calsoft-header30 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header30>
            }
            @if (type == 'thirtyone') {
            <calsoft-header31 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header31>
            }
            @if (type == 'thirtytwo') {
            <calsoft-header32 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header32>
            }
            @if (type == 'thirtythree') {
            <calsoft-header33 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header33>
            }
            @if (type == 'thirtyfour') {
            <calsoft-header34 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header34>
            }
            @if (type == 'thirtyfive') {
            <calsoft-header35 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray"
              [scrollvalue]="scroll_value">
            </calsoft-header35>
            }
            @if (type == 'thirtysix') {
            <calsoft-header36 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray"
              [scrollvalue]="scroll_value">
            </calsoft-header36>
            }
            @if (type == 'thirtyseven') {
            <calsoft-header37 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header37>
            }
            @if (type == 'thirtyeight') {
            <calsoft-header38 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header38>
            }
            @if (type == 'thirtynine') {
            <calsoft-header39 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header39>
            }
            @if (type == 'fourty') {
            <calsoft-header40 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header40>
            }
            @if (type == 'fourtyone') {
            <calsoft-header41 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header41>
            }
            @if (type == 'fourtytwo') {
            <calsoft-header42 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header42>
            }
            @if (type == 'fourtythree') {
            <calsoft-header43 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header43>
            }
            @if (type == 'fourtyfour') {
            <calsoft-header44 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header44>
            } -->
            @if (type == 'fourtyfive') {
            <calsoft-header45 [data]="finalData" [languageSelection]="languageSelection" [item]="categoryArray">
            </calsoft-header45>
            }
            <!-- @if(type == 'fourtysix'){

              <calsoft-header46  [data]="finalData" [languageSelection]="languageSelection"
              [item]="categoryArray">
        
              </calsoft-header46>
        
            } -->

          </div>
          }
          <ng-container>
            <div class="theme-container main" [ngStyle.gt-md]="{
                  'padding-top':type == 'fourtythree' ? '0px' : type == 'thirtyfour' ? '120px' :
                                  type == 'thirtyfive' ? '90px' : ''
                  }">
              <!-- <div class="theme-container main" [ngStyle.gt-md]="{
                  'padding-top': type == 'thirtyfour' ? '120px' :
                                  type == 'thirtyfive' ? '90px' :
                                  type == 'thirtyone' ? '50px' : ''
              }"> -->
         
              @if (breadCrumpDisable ) {
              <div [ngStyle]="{'display':hideBreadcrump ? 'none' : '' }" class="container">
                <calsoft-breadcrumb fxHide fxShow.gt-sm></calsoft-breadcrumb>
              </div>
              }
              <div>
                <div class="main12" 
                  (touchstart)=" finalData.mobileLeftRightScroll==1?onTouchStart($event):''"
                  (touchend)=" finalData.mobileLeftRightScroll==1?onTouchEnd($event):''">
                  <router-outlet></router-outlet>
                  @if (showPopup) {
                  <!-- <calsoft-newsletter-ads></calsoft-newsletter-ads> -->
                  }
                </div>
              </div>
            </div>
          </ng-container>
          @if (displayFooterOnMOb&&!defaultFooter) {
          <div class="visiblity12">
            <div fxHide fxShow.gt-sm>
               
            </div>
          </div>
          }
          @if (enableFooterWebsite==0 && !this.loginPage ) {
          <div>
           @if (!display && type != 'twentyseven') {
            <div [ngClass]="noPaddingFooter==0 ? 'margin-t10' : ''">
              <!-- @if (footerLayout == 1) {
              <calsoft-footer [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg>
              </calsoft-footer>
              }
              @if (footerLayout == 5) {
              <calsoft-footer4 [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg></calsoft-footer4>
              }
              @if (footerLayout == 4) {
              <calsoft-footer3 [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg></calsoft-footer3>
              }
              @if (footerLayout == 3) {
              <calsoft-footer2 [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg></calsoft-footer2>
              }
              @if (footerLayout == 2) {
              <calsoft-footer1 [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg></calsoft-footer1>
              }
              @if (footerLayout == 6) {
              <calsoft-footer5 [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg></calsoft-footer5>
              }
              @if (footerLayout == 7) {
              <calsoft-footer6 [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg></calsoft-footer6>
              }
              @if (footerLayout == 8) {
              <calsoft-footer7 [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg></calsoft-footer7>
              }
              @if (footerLayout == 9) {
              <calsoft-footer8 [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg></calsoft-footer8>
              }
              @if (footerLayout == 10) {
              <calsoft-footer9 [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg></calsoft-footer9>
              }
              @if (footerLayout == 11) {
              <calsoft-footer10 [data]="finalData" fxHide fxShow.md fxShow.lg fxShow.gt-lg></calsoft-footer10>
              } -->
              @if (footerLayout == 13) {
              <calsoft-dynamic-footer [data]="finalData" fxHide fxShow.md fxShow.lg
                fxShow.gt-lg></calsoft-dynamic-footer>

              }
            </div>
            }
          </div>
          }
          @if (display && type != 'twentyseven' && !this.loginPage) {
          <div [ngClass]="noPaddingFooter==0 ? 'margin-t10' : ''">
            <!-- @if (footerLayout == 1) {
            <calsoft-footer [data]="finalData"> </calsoft-footer>
            }
            @if (footerLayout == 5) {
            <calsoft-footer4 [data]="finalData"></calsoft-footer4>
            }
            @if (footerLayout == 4) {
            <calsoft-footer3 [data]="finalData"></calsoft-footer3>
            }
            @if (footerLayout == 3) {
            <calsoft-footer2 [data]="finalData"></calsoft-footer2>
            }
            @if (footerLayout == 2) {
            <calsoft-footer1 [data]="finalData"></calsoft-footer1>
            }
            @if (footerLayout == 6) {
            <calsoft-footer5 [data]="finalData"></calsoft-footer5>
            }
            @if (footerLayout == 7) {
            <calsoft-footer6 [data]="finalData"></calsoft-footer6>
            }
            @if (footerLayout == 8) {
            <calsoft-footer7 [data]="finalData"></calsoft-footer7>
            }
            @if (footerLayout == 9) {
            <calsoft-footer8 [data]="finalData"></calsoft-footer8>
            }
            @if (footerLayout == 10) {
            <calsoft-footer9 [data]="finalData"></calsoft-footer9>
            }
            @if (footerLayout == 11) {
            <calsoft-footer10 [data]="finalData"></calsoft-footer10>
            } -->
            @if (footerLayout == 13) {
            <calsoft-dynamic-footer [data]="finalData"></calsoft-dynamic-footer>

            }
          </div>
          }
          @if (enableFooterWebsite==1) {
          <div>
            <div [ngClass]="noPaddingFooter==0 ? 'margin-t10' : ''">
            </div>
          </div>
          }
          @if (footerScrollTextEnable && !this.loginPage) {
          <div>
            @if (url=='/home') {
            <div>
              <br>
              <br>
              <br>
              @if (!displayFooterOnMOb) {
              <br>
              }
              @if (!displayFooterOnMOb) {
              <br>
              }
            </div>
            }
            <!-- <calsoft-footer-header [data]="finalData"></calsoft-footer-header> -->
          </div>
          }
          <!-- <div *ngIf="showBackToTop" fxLayout="row" fxLayoutAlign="center center" >
                  <div class="icon-box" *ngIf="footerScrollTextEnable">
                      <calsoft-footer-header [data]="finalData"></calsoft-footer-header>
                  </div>
                  </div> -->
          @if (displayFooterOnMOb&&url!='/cart'
          && !url.includes('/product/') && !this.loginPage
          && url!='/checkout' && url!='/checkout/type') {
          <div fxHide fxShow.lt-lg>
            <br>
            <br>
            <br>
          </div>
          }
          @if (!url.includes('/product/') && !this.loginPage) {
          <span>
            @if (displayFooterOnMOb) {
            @if (url!='/cart' && url!='/checkout' && url!='/checkout/type') {
            <footer fxHide.lg fxHide.gt-lg class="_fijon mat-elevation-z6 sticky mat-elevation-z7">
              <div fxLayout="row" fxLayoutAlign="space-between center">
                @for (item of footerMenu; track item; let i = $index) {
                <div fxFlex fxLayout="column" fxLayoutAlign="center center">
                  <button [color]="item.url==currentUrl?'primary':null" (click)="account(i,item.secured)"
                    [class]="item.url==currentUrl?'material-icons':'material-icons-outlined'" mat-icon-button>
                    @if (item.url!='/cart') {
                    <mat-icon class="primary-icon">{{item.icon}}</mat-icon>
                    }
                    @if (item.url=='/cart') {
                    <!-- <mat-icon class="primary-icon"
                      [matBadge]="userLoggedIn&&cartServices.cartCount!=0?cartServices.cartCount:''"
                      matBadgePosition="above after" matBadgeColor="accent">
                      shopping_cart
                    </mat-icon> -->
                    }
                  </button>
                  <small>{{item.name}}</small>
                </div>
                }
              </div>
            </footer>
            }
            }
          </span>
          }
        </div>
      </div>
       </div> 
      @if (showBackToTop) {
      <div fxLayout="row" fxLayoutAlign="center center" class="tap-top top-cls primary" (click)="scrollToTop()">
        <mat-icon>arrow_upward</mat-icon>
      </div>
      }
      @if (enableWhatsappChat==1&&!meetingUrl) {
      <div fxLayout="row" fxLayoutAlign="center center" style="background: #E7F3EC;" class="whatsapp top-cls" cdkDrag
        (click)="navigate()">
        <img style="height: 30px;" src="assets/icons/whatsapp.svg" alt="whatsapp">
      </div>
      }
      @if (displayDeliveryIcon==1) {
      <div fxLayout="row" fxLayoutAlign="center center" style="background: #E7F3EC;" class=" delivery top-cls">
        <img style="height: 64px;" (click)="navigateTo(finalData.deliveryIconNavigationLink)"
          onerror="this.src='assets/icons/Medical Delivery-01.svg';" [src]="serverPath6 + deliveryIconImage"
          [alt]="deliveryIconImage">
      </div>
      }
    </div>
</div>

}